module.exports = __webpack_public_path__ + "img/device-guru.b733a81d.png";